import { render, staticRenderFns } from "./PremiumChartModal.vue?vue&type=template&id=65071f8b&scoped=true"
import script from "./PremiumChartModal.vue?vue&type=script&lang=js"
export * from "./PremiumChartModal.vue?vue&type=script&lang=js"
import style0 from "./PremiumChartModal.vue?vue&type=style&index=0&id=65071f8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65071f8b",
  null
  
)

export default component.exports